import { ErrorDetailsSpecifier, PreCheckErrorMessages } from '../../errors/pre-check/pre-check-error';

export function mapErrorDetailsToMessageKey(details: ErrorDetailsSpecifier, isLinear: boolean): keyof PreCheckErrorMessages {
    switch (details) {
        case ErrorDetailsSpecifier.MinComboBetsCount:
            return 'minComboBetsCount';

        case ErrorDetailsSpecifier.MinSystemBetsCount:
            return 'minSystemBetsCount';

        case ErrorDetailsSpecifier.PicksMaximum:
            return 'PicksMaximum';

        case ErrorDetailsSpecifier.SelectMaxComboBets:
            return 'SelectMaxComboBets';

        case ErrorDetailsSpecifier.SelectMaxRaceComboBets:
            return 'SelectMaxRaceComboBets';

        case ErrorDetailsSpecifier.SelectMaxSystemBets:
            return 'SelectMaxSystemBets';

        case ErrorDetailsSpecifier.SelectMinComboBets:
            return isLinear ? 'SelectMinComboBetsLinear' : 'SelectMinComboBets';

        case ErrorDetailsSpecifier.SelectMinSingleBets:
            return 'SelectMinSingleBets';

        case ErrorDetailsSpecifier.SelectMinSystemBets:
            return 'SelectMinSystemBets';

        case ErrorDetailsSpecifier.SelectMaxSystemBetsBanker:
            return 'SelectMaxSystemBetsBanker';

        case ErrorDetailsSpecifier.SelectMinSystemBetsBanker:
            return 'SelectMinSystemBetsBanker';

        case ErrorDetailsSpecifier.SelectMaxTeaserBets:
            return 'SelectMaxTeaserBets';

        case ErrorDetailsSpecifier.SelectMinTeaserBets:
            return 'SelectMinTeaserBets';

        case ErrorDetailsSpecifier.MinTeaserBetsCount:
            return 'MinTeaserBetsCount';

        case ErrorDetailsSpecifier.ForecastSystemBet:
            return 'ForecastSystemBet';
    }
}
